require('../../brokerPensionPlanContribution.scss');
require('./pensionPlanExtraordinaryStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @commons
const PensionPlanContributionSummary = require('components/broker/commons/pensionPlanContributionSummary/pensionPlanContributionSummary');

// @helpers
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    FIRST_STEP,
    CHARGE_ACCOUNT_PREFIX,
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    EURO_TEXT,
    SECOND_STEP,
    BROKER_PRODUCT_TYPE_PLANS
} = require('constants/index');

const { BROKER_PLAN_CONTRIBUTION_ID, BROKER_PLAN_PERIODIC_CONTRIBUTION_ID } = require('constants/operationTypes');

// @ components
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const { ConfirmationScript, CONFIRMATION_SCRIPT_GREETING, CONFIRMATION_SCRIPT_AGREEMENT } = require('components/contactCenter/confirmScript/confirmationScript');
const { BrokerPlanLegalDocumentDisclaimer } = require('components/broker/brokerPlanLegalDocumentDisclaimer/brokerPlanLegalDocumentDisclaimer');
import BrokerLegalDocumentation from 'components/broker/brokerLegalDocumentation/brokerLegalDocumentation';
const { OKMessage } = require('commonsComponents/OKMessage');

const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

class pensionPlanExtraordinaryStep2 extends React.Component {
    buildDisclaimerCheckbox() {
        const { immPensionPlanContribution, onToggleDisclaimer, setDocumentsRead } = this.props;
        let documentsNotRead = null;
        if (immPensionPlanContribution.getIn(['steps', SECOND_STEP, 'showWarning'])) {
            documentsNotRead = (
                <div className="broker-pension-plan-contribution-step2__warning-message">
                    <OKMessage type="warning">
                        <FormattedText value="brokerLegalDocumentation-documentsRead" />
                    </OKMessage>
                </div>
            );
        }
        const tealium ={
            categoriaEvento: 'broker/aporte-planes-pension',
            accionEvento: 'leer'
        };
        return (
            <WebappRender>
                <BrokerLegalDocumentation
                    className="broker-pension-plan-contribution-step2__documentation-box"
                    isAportation={false}
                    productDefinition={immPensionPlanContribution.getIn(['pensionPlan', 'Name'])}
                    productType={BROKER_PRODUCT_TYPE_PLANS}
                    planDgsCode={immPensionPlanContribution.getIn(['pensionPlan', 'DGSCode'])}
                    reportCompleted={() => setDocumentsRead()}
                    tealium={tealium}
                />
                {documentsNotRead}
                <div className="broker-pension-plan-contribution-step2__read-terms">
                    <BrokerPlanLegalDocumentDisclaimer
                        disclaimerErrorState={immPensionPlanContribution.getIn(['steps', SECOND_STEP, 'disclaimerInvalid'])}
                        disclaimerErrorMessage={formatText('pensionPlanContribution-disclaimerError')}
                        disclaimerChecked={immPensionPlanContribution.getIn(['steps', SECOND_STEP, 'disclaimerChecked'])}
                        onDisclaimerCheckChange={onToggleDisclaimer}
                        planName={immPensionPlanContribution.getIn(['pensionPlan', 'Name'])}
                        planDgsCode={immPensionPlanContribution.getIn(['pensionPlan', 'DGSCode'])}
                        planSecId={immPensionPlanContribution.getIn(['pensionPlan', 'SecId'])}
                        isAportation={true}
                    />
                </div>
            </WebappRender>
        );
    }

    createFooter(operationType, operationParams) {
        let signaturePattern = null;
        if (this.props.immPensionPlanContribution.getIn(['steps', SECOND_STEP, 'disclaimerChecked'])) {
            signaturePattern = (
                <footer>
                    <section className="broker-pension-plan-contribution-step2__signature-pattern-section">
                        <SignaturePattern
                            operationType={operationType}
                            operationParams={operationParams}
                        />
                    </section>
                </footer>
            )
        }
        return signaturePattern;
    }

    render() {
        const { immPensionPlanContribution } = this.props;
        const step1 = immPensionPlanContribution.get('steps').get(FIRST_STEP);
        const plan = immPensionPlanContribution.get('pensionPlan');
        const walletPlan = immPensionPlanContribution.get('pensionPlanFromWallet');
        const contractNumber = walletPlan.getIn(['contrato', 'numerodecontrato']);
        const productNumber = walletPlan.getIn(['contrato', 'producto']);
        const chargeAccount = `${CHARGE_ACCOUNT_PREFIX}${productNumber}${contractNumber}`;
        const planData = immPensionPlanContribution.get('extraordinaryData');
        const validationData = immPensionPlanContribution.get('validationData');
        const operative = formatText('operatives-pensionPlansExtraordinaryContribution');
        let currency;
        if (step1.get('setPeriodicity')) {
            currency = (validationData ? validationData.get('codmonProd') : EURO_TEXT);
        } else {
            currency = (planData ? planData.get('divisaDelMovimiento') : EURO_TEXT);
        }
        const amount = (!step1.get('setPeriodicity') ? step1.get('originalAmount') : step1.get('periodiclyAmount'));
        const operationType = (!step1.get('setPeriodicity') ? BROKER_PLAN_CONTRIBUTION_ID : BROKER_PLAN_PERIODIC_CONTRIBUTION_ID);
        const operationParams = {
            'ammount': amount,
            'currency': currency,
            'originAccount': chargeAccount
        };
        return (
            <div className="broker-pension-plan-contribution">
                <header className="broker-pension-plan-contribution__header">
                    <h2 className="broker-pension-plan-contribution__title broker-pension-plan-contribution-step2__title">
                        <FormattedText value="pensionPlanContribution-step2Title" />
                    </h2>
                    <ContactCenterRender>
                        <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING} />
                    </ContactCenterRender>
                    <p className="broker-pension-plan-contribution-step2__subtitle">
                        <FormattedText value="pensionPlanContribution-step2SubTitle" />
                    </p>
                </header>
                <section>
                    <h2 className="broker-pension-plan-contribution__title broker-pension-plan-contribution-step2__title">
                        <FormattedText value="pensionPlanContribution-step1Title" />
                    </h2>
                    <PensionPlanContributionSummary
                        productName={formatText('broker-etfProductName')}
                        plan={plan}
                        walletPlan={walletPlan}
                        planData={planData}
                        validationData={validationData}
                        planContractNumber={chargeAccount}
                        step1={step1}
                        modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER}
                        columns={4}
                    />
                </section>
                <WebappRender>
                    {this.buildDisclaimerCheckbox()}
                </WebappRender>
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                {this.createFooter(operationType, operationParams)}
            </div>
        );
    }

}

pensionPlanExtraordinaryStep2.propTypes = {
    immPensionPlanContribution: PropTypes.object.isRequired,
    onToggleDisclaimer: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
};

module.exports = pensionPlanExtraordinaryStep2;
